@let checkInSourcePosition =
  checkInFeature.selectors.checkInSourcePosition.asSignal();
@let checkInCurrentMoodCandidates =
  checkInFeature.selectors.checkInCurrentMoodCandidates.asSignal();

@if (checkInSourcePosition) {
  <atn-ds-attached-overlay
    [origin]="checkInSourcePosition.origin"
    [offsetX]="checkInSourcePosition.offsetX"
    [offsetY]="checkInSourcePosition.offsetY"
  >
    <div class="atn-check-in-mood-pop-up">
      @for (candidate of checkInCurrentMoodCandidates; track candidate) {
        <div
          class="atn-check-in-mood-pop-up__candidate"
          (click)="
            checkInFeature.actions.giveCurrentMood
              .from('CurrentMoodPopUp.Candidate.Clicked')
              .dispatch(candidate)
          "
        >
          {{ candidate }}
        </div>
      }
      <div
        class="atn-check-in-mood-pop-up__skip"
        (click)="
          checkInFeature.actions.giveCurrentMood
            .from('CurrentMoodPopUp.Skip.Clicked')
            .dispatch(undefined)
        "
      >
        Skip
      </div>
    </div>
  </atn-ds-attached-overlay>
}
